export default "__VITE_PUBLIC_ASSET__7658f40e__"